module.exports = {"regions":["us-east-2","us-east-1","us-west-1","us-west-2","ap-northeast-1","ap-northeast-2","ap-south-1","ap-southeast-1","ap-southeast-2","ca-central-1","eu-central-1","eu-west-1","eu-west-2","eu-west-3","sa-east-1"]}


//////////////////
// WEBPACK FOOTER
// ./src/components/universal/resources/regions.json
// module id = 122
// module chunks = 0